export const VARZ = {
  apiBaseUrl: process.env.REACT_APP_PUBLIC_API_URL,
  assetsBaseUrl: process.env.REACT_APP_PUBLIC_ASSETS_URL,
  tinyMCEApi: process.env.REACT_APP_PUBLIC_TINY_MCE,
  perPage: 30,
  priceUnit: process.env.REACT_APP_PUBLIC_UNIT_PRICE ?? "تومان",
};
